// extracted by mini-css-extract-plugin
export default {"headCard":"chapterDetailsPage_headCard__7VzKc","cardCustom":"chapterDetailsPage_cardCustom__wEXYt","cardBodyCustom":"chapterDetailsPage_cardBodyCustom__h0AnD"};